import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Alert, AlertDescription } from '../ui/alert';
import { CheckCircle, FileSignature, Info, RefreshCw } from 'lucide-react';
import SignatureMethodSelector from './SignatureMethodSelector';

export default function ResultatSignature({
  savedSimulation, identite, otpSent, signingInProgress,
  signatureMethod, signatureDestination, otpCode, setOtpCode,
  handleInitiateSignature, handleValidateSignature, handleResendOTP
}) {
  if (savedSimulation.signature?.statut === 'signed') return null;

  return (
    <Card className="border-2 border-purple-200 bg-purple-50/30">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2 text-purple-700">
          <FileSignature className="h-5 w-5" />
          Signature electronique
        </CardTitle>
        <p className="text-sm text-gray-600 mt-1">
          Signez electroniquement vos documents CG/CP via un code de validation envoye par SMS ou email.
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        {!otpSent ? (
          <SignatureMethodSelector
            identite={identite}
            signingInProgress={signingInProgress}
            signatureMethod={signatureMethod}
            handleInitiateSignature={handleInitiateSignature}
            reference={savedSimulation.reference}
          />
        ) : (
          <div className="space-y-4">
            <Alert className="border-purple-200 bg-purple-100">
              <Info className="h-4 w-4 text-purple-600" />
              <AlertDescription className="text-purple-800">
                Un code a 6 chiffres a ete envoye {signatureMethod === 'sms' ? 'par SMS au' : 'par email a'} <strong>{signatureDestination || identite.email}</strong>
              </AlertDescription>
            </Alert>

            <div className="flex gap-3 items-center justify-center">
              <Input
                type="text"
                maxLength={6}
                placeholder="000000"
                value={otpCode}
                onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                className="w-40 text-center text-2xl font-mono tracking-widest"
                data-testid="input-otp"
              />
            </div>

            <div className="flex gap-3 justify-center">
              <Button
                variant="outline"
                onClick={() => handleResendOTP(savedSimulation.reference)}
              >
                Renvoyer le code
              </Button>
              <Button
                onClick={() => handleValidateSignature(savedSimulation.reference)}
                disabled={signingInProgress || otpCode.length !== 6}
                className="bg-purple-600 hover:bg-purple-700"
                data-testid="btn-validate-signature"
              >
                {signingInProgress ? (
                  <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                ) : (
                  <CheckCircle className="h-4 w-4 mr-2" />
                )}
                Valider la signature
              </Button>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
